/* eslint-disable arrow-body-style */
import React, { useState } from 'react';
import { Modal } from '@mui/material';
import { StyledModalBox } from '../instructors/styles';
import CustomLoggerFilterForm from './CustomLoggerFilterForm';

interface CustomLoggersModalProps {
  open: boolean;
  onClose: () => void;
  onApplyFilters: (filterOptions: any) => void;
}

const CustomLoggersModal: React.FC<CustomLoggersModalProps> = ({
  open,
  onClose,
  onApplyFilters,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <StyledModalBox>
        <CustomLoggerFilterForm open={open} onClose={onClose} onApplyFilters={onApplyFilters} />
      </StyledModalBox>
    </Modal>
  );
};

export default CustomLoggersModal;
